import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Route, Routes, Navigate } from "react-router-dom";

// import IndexPage from "@/pages/index";
import MeetingsPage from '@/pages/meetings/meetings';
import AdminMeetingsPage from '@/pages/meetings/admin-meetings';
import ProfilePage from '@/pages/account-page';
// import AboutPage from "@/pages/about";
import LoginPage from "@/pages/login-page";
import MeetingDetailsPage from './pages/meetings/meeting-details-page';
import ActiveMeetingsPage from './pages/meetings/active-meetings-page';
import CreateMeetingPage from './pages/meetings/create-meeting-page';
import EditMeetingPage from './pages/meetings/edit-meeting-page';
import './styles/nprogress.css'

function App() {
  return (
    <>
      {/* Routes for signed-out users */}
      <SignedOut>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/*" element={<Navigate to={'/'} replace/>} />
        </Routes>
      </SignedOut>

      {/* Routes for signed-in users */}
      <SignedIn>
        <Routes>
          <Route path="/" element={<MeetingsPage />} />
          <Route path="/:tab_id" element={<MeetingsPage />} />
          <Route path="/meetings" element={<MeetingsPage />} />
          <Route path="/meetings/:tab_id" element={<MeetingsPage />} />
          <Route path='/meetings/new' element={<CreateMeetingPage/>}/>
          <Route path='/meetings/edit/:short_code' element={<EditMeetingPage/>}/>
          <Route path='/meetings/join/:short_code' element={<ActiveMeetingsPage/>}/>
          <Route path='/meetings/view/:short_code' element={<MeetingDetailsPage/>}/>
          <Route path="/admin/meetings" element={<AdminMeetingsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/*" element={<Navigate to={'/'} replace/>} />
        </Routes>
      </SignedIn>
    </>
  );
}

export default App;